import { blockSpec } from '../domain/blocks';
import type { BlockType } from '../domain/types';
import { BLOCK_ICONS } from './icons';

/** O ícone de um tipo de bloco. */
export function BlockGlyph({ type, className }: { type: BlockType; className?: string }) {
  const Glyph = BLOCK_ICONS[blockSpec(type).icon];
  return <Glyph aria-hidden className={className} />;
}
